// 洞洞杂货铺 · 热门文章与首页推荐数据
export interface Article {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  readTime: string;
  tag: string;
  image: string;
  link: string;
}

export const hotArticles: Article[] = [
  {
    id: "dongdong-meaning",
    title: "洞洞到底是什么意思？解开「洞洞」这个词的九层隐喻",
    excerpt:
      "从物理意义上的墙洞，到记忆的裂隙、时空的交汇点……「洞洞」在杂货铺里远不止是一个可爱称呼。它既是通往其他世界的入口，也是整部漫画世界观的地基。",
    category: "洞洞含义",
    date: "2026-08-18",
    readTime: "8 分钟",
    tag: "核心设定",
    image:
      "https://readdy.ai/api/search-image?query=A%20cozy%20warm%20illustrated%20grocery%20store%20wall%20with%20a%20softly%20glowing%20mysterious%20circular%20hole%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20hand%20drawn%20storybook%20style%2C%20fantasy%20portal%20light%20spilling%20from%20the%20opening%2C%20gentle%20sparkles%2C%20nostalgic%20cozy%20atmosphere&width=900&height=600&seq=article-dongdong-01&orientation=landscape",
    link: "/worldview",
  },
  {
    id: "shop-space",
    title: "杂货铺的空间设定：一间永远走不到尽头的店铺",
    excerpt:
      "推开那扇嘎吱作响的木门之后，你会发现这家店比从外面看上去要「深」得多。货架之间藏着多少层空间？店主又是如何在这片无限之地里经营日常的？",
    category: "世界观",
    date: "2026-08-15",
    readTime: "10 分钟",
    tag: "空间法则",
    image:
      "https://readdy.ai/api/search-image?query=A%20warm%20cozy%20hand%20drawn%20illustration%20of%20a%20magical%20general%20store%20interior%20with%20endless%20wooden%20shelves%20receding%20into%20the%20distance%2C%20warm%20lantern%20light%2C%20cream%20and%20amber%20palette%2C%20storybook%20fantasy%20atmosphere%2C%20detailed%20illustrated%20background&width=900&height=600&seq=article-shop-02&orientation=landscape",
    link: "/settings",
  },
  {
    id: "time-rules",
    title: "时间规则：为什么杂货铺里的钟总是慢一小时？",
    excerpt:
      "在杂货铺里，挂在墙上的老钟看似只是装饰，却隐藏着整部作品的时间法则。洞洞连接的不同时间线，如何影响顾客与店主的每一次相遇？",
    category: "故事背景",
    date: "2026-08-12",
    readTime: "7 分钟",
    tag: "时间设定",
    image:
      "https://readdy.ai/api/search-image?query=A%20warm%20illustrated%20old%20pendulum%20clock%20on%20a%20cozy%20grocery%20store%20wall%20with%20soft%20glowing%20numbers%2C%20vintage%20storybook%20style%2C%20amber%20and%20cream%20palette%2C%20fantasy%20time%20concept%2C%20gentle%20dreamy%20light%2C%20hand%20drawn&width=900&height=600&seq=article-time-03&orientation=landscape",
    link: "/worldview",
  },
  {
    id: "hidden-clues",
    title: "那些藏在货架缝隙里的隐藏线索，你都发现了吗？",
    excerpt:
      "每隔三话就会出现的同款绿色玻璃瓶、角落贴纸上反复出现的手写数字……这些不起眼的小物件，其实是串联起整部漫画核心谜题的暗号。",
    category: "隐藏线索",
    date: "2026-08-08",
    readTime: "9 分钟",
    tag: "考据",
    image:
      "https://readdy.ai/api/search-image?query=A%20warm%20hand%20drawn%20illustration%20of%20old%20grocery%20store%20shelves%20with%20small%20mysterious%20objects%20and%20glass%20bottles%2C%20hand%20written%20notes%20and%20numbers%20on%20paper%20tags%2C%20cozy%20amber%20lighting%2C%20storybook%20mystery%20atmosphere%2C%20cream%20palette&width=900&height=600&seq=article-clue-04&orientation=landscape",
    link: "/settings",
  },
];

export const heroFeatures: Article[] = [
  {
    id: "hero-worldview",
    title: "世界观总览",
    excerpt: "一张图理清洞洞杂货铺的世界架构：洞洞从哪里来，又通向哪里。",
    category: "世界观解析",
    date: "",
    readTime: "",
    tag: "入坑必读",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20illustrated%20fantasy%20map%20of%20a%20cozy%20grocery%20store%20world%2C%20glowing%20circular%20portals%20connecting%20different%20colorful%20realms%2C%20storybook%20style%2C%20amber%20teal%20and%20cream%20palette%2C%20hand%20drawn%20worldbuilding%20chart&width=800&height=560&seq=hero-worldview-a&orientation=landscape",
    link: "/worldview",
  },
  {
    id: "hero-characters",
    title: "角色图鉴",
    excerpt: "店主、洞洞猫与常客们的档案与关系网，读懂每个角色背后的伏笔。",
    category: "角色关系",
    date: "",
    readTime: "",
    tag: "人物档案",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20illustrated%20portraits%20of%20storybook%20fantasy%20grocery%20store%20characters%2C%20friendly%20shopkeeper%20and%20cute%20cat%2C%20amber%20and%20cream%20palette%2C%20hand%20drawn%20chibi%20style%2C%20cozy%20character%20art&width=800&height=560&seq=hero-char-b&orientation=landscape",
    link: "/characters",
  },
  {
    id: "hero-settings",
    title: "设定百科",
    excerpt: "店铺设定、洞洞法则与隐藏线索的完整辞条，随查随用。",
    category: "设定大全",
    date: "",
    readTime: "",
    tag: "考据工具",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20illustrated%20open%20storybook%20encyclopedia%20with%20sketches%20of%20glowing%20holes%20and%20store%20shelves%2C%20amber%20and%20cream%20palette%2C%20hand%20drawn%20fantasy%20reference%20book%2C%20cozy%20study%20atmosphere&width=800&height=560&seq=hero-set-c&orientation=landscape",
    link: "/settings",
  },
];